const scrollMixin = {
  data() {
    return {
      position: 0,
    };
  },
  methods: {
    toggleBodyScrolling(value) {
      if (value) {
        this.enableBodyScrolling();
      } else {
        this.disableBodyScrolling();
      }
    },
    disableBodyScrolling() {
      const body = document.querySelector('body');
      this.position = window.scrollY;

      const overflownElement = document.querySelector('#app');
      const absoluteElement = document.querySelector('#appLoader');
      let scrollWidth = 0;

      if (absoluteElement && overflownElement) {
        scrollWidth =
          absoluteElement.offsetWidth - overflownElement.offsetWidth;
      }

      body.style.cssText = `top:-${window.scrollY}px;height:auto;position:fixed;width:calc(100% - ${scrollWidth}px)`;
    },
    enableBodyScrolling() {
      const body = document.querySelector('body');
      body.style.cssText = '';
      window.scrollTo(0, this.position);
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};

export default scrollMixin;
